import React from 'react'
import "./b2cProfits.scss"

//Imagens:
import ImgB2cProfits from "../../../../assets/retail/vetorRetail.png"
import { useTranslation } from 'react-i18next'

function B2cProfits() {
  const {t} =  useTranslation()

  return (
    <div className='container-b2c-profits'>
        <div className="img-b3c-profits">
            <img src={ImgB2cProfits} alt="" />
        </div>
        <div className='texts-b2c-profits'>
            <h1>{t("retail.title")}</h1>
            <p>{t("retail.section_text")}</p>
            <a href="/form">
              <button id='btn-b3c-profits'>{t("buttons.demo_btn_alternative_text_1")}</button>
            </a>
        </div>
    </div>
  )
}

export default B2cProfits